import React, { useCallback, useState } from 'react';
import { Button, Dropdown, MenuProps } from 'antd';
import { useSelector } from 'react-redux';
import { t } from 'ttag';
import {
  CommentOutlined,
  LinkOutlined,
  MailOutlined,
  PhoneOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';

import { getUser } from '../state/user';

import { open as openHubSpot } from '../services/support';

import { SUPPORT_EMAIL, SupportPhoneUrl, SupportPhone } from '../services/support/types';
import useTranslation from '../hooks/useTranslation';
import Portal from '../types/Portal';

const KNOWLEDGE_BASE_URL = 'https://help.eventmobi.com/en/knowledge';

const HelpDropdown = () => {
  const { locale } = useTranslation();
  const user = useSelector(getUser);
  const [hubspotLoaded, setHubspotLoaded] = useState(false);

  const supportPhoneUrl = /de/.test(locale) ? SupportPhoneUrl.DE : SupportPhoneUrl.EN;
  const supportPhone = /de/.test(locale) ? SupportPhone.DE : SupportPhone.EN;

  const checkHubspot = useCallback(() => {
    const loaded = !!document.getElementById('hs-script-loader');
    setHubspotLoaded(loaded);
  }, []);

  const openChat = () => {
    openHubSpot({ email: user.email }, Portal.CompanyPortal);
  };

  const items: MenuProps['items'] = [
    {
      key: 'knowledge-base',
      icon: <LinkOutlined />,
      label: (
        <a href={KNOWLEDGE_BASE_URL} target="_blank" rel="noopener noreferrer">
          {t`Visit our Knowledge Base`}
        </a>
      ),
    },
    { key: 'divider-1', type: 'divider', style: { marginTop: 0, marginBottom: 0 } },
    {
      key: 'contact-us',
      label: t`Contact Us`,
      type: 'group',
    },
    hubspotLoaded && {
      key: 'chat',
      onClick: openChat,
      icon: <CommentOutlined />,
      label: t`Live Chat`,
    },
    {
      key: 'call-us',
      icon: <PhoneOutlined />,
      label: <a href={supportPhoneUrl}>{t`Call us ${supportPhone}`}</a>,
    },
    {
      key: 'email',
      icon: <MailOutlined />,
      label: <a href={`mailto:${SUPPORT_EMAIL}`}>{t`Email ${SUPPORT_EMAIL}`}</a>,
    },
  ].filter(Boolean);

  return (
    <Dropdown trigger={['click']} onOpenChange={checkHubspot} menu={{ items }}>
      <Button style={{ color: '#1890FF', borderColor: '#1890FF' }}>
        <QuestionCircleOutlined />
        {t`Help`}
      </Button>
    </Dropdown>
  );
};

export default HelpDropdown;
